<template>
  <div>
    <div class="flex items-center">
      <input class="w-9/12 h-6" type="text" placeholder="Suchbegriff..." v-model="searchTerm"
             v-on:keyup.enter="search" data-ui="input-image-search">
      <div @click="clearSearch"
           class="w-1/12 mr-1 h-6 bg-white   flex justify-center items-center hover:bg-active hover:text-white cursor-pointer"
           data-ui="button-clear-search">
        <i class="fa-solid fa-circle-xmark"></i>
      </div>
      <div @click="search"
           class="w-1/12 mr-1 h-6 bg-white flex justify-center items-center hover:bg-active hover:text-white cursor-pointer"
           data-ui="button-search-image">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      <div @click="prevPage"
           class="bg-white px-2 py-1 hover:bg-active hover:text-white cursor-pointer" data-ui="button-prev-page">
        <i class="fa-solid fa-arrow-left"></i>
      </div>
      <div @click="nextPage"
           class="bg-white px-2 py-1 hover:bg-active hover:text-white cursor-pointer" data-ui="button-next-page">
        <i class="fa-solid fa-arrow-right"></i>
      </div>
    </div>
    <div class="flex mb-2 mt-2">
      <div class="w-2/6">
        <button class="p-1 w-1/2  hover:bg-active hover:text-white cursor-pointer" @click="toggle('picture')"
                data-ui="button-select-search-picture"
                :class="{ 'bg-active text-white': selectedOption === 'picture', 'bg-white': selectedOption !== 'picture' }">
          Bilder
        </button>
        <button class="p-1 w-1/2 hover:bg-active hover:text-white cursor-pointer " @click="toggle('logo')"
                data-ui="button-select-search-logo"
                :class="{ 'bg-active text-white': selectedOption === 'logo', 'bg-white': selectedOption !== 'logo' }">
          Logos
        </button>
      </div>
      <select class="w-4/6 ml-1" v-model="selectedTeam" v-on:change="search">
        <option value="0">Alle</option>
        <option v-for="team in teams" :value="team.id">{{ team.name }}</option>
      </select>
    </div>
    <div v-if="searchResult?.length > 0 && pageCount > 0" class="flex mb-2">
      Seiten {{ page + 1 }} von {{ pageCount }}
    </div>
    <div class="grid grid-cols-3 gap-2">

      <spinner v-if="isLoading" class="col-span-4 w-full"/>

      <div class="col-span-4 w-full" v-if="images.length <= 0 && !isLoading ">
        Kein Ergebnis mit diesen Begriff gefunden
      </div>

      <div v-for="image in images" class="flex flex-col bg-white flex-grow">


        <div class="flex flex-col justify-center items-center flex-2 h-[120px]">

          <div class="flex-grow w-full relative"
               @mouseover="mouseEnter(image)"
               @mouseleave="mouseLeave">

            <!-- Container für Bild und Icon -->
            <div class="absolute w-full h-full flex justify-center items-center">
              <img class=" max-h-[70px] max-w-[70px] z-0" :src="image?.previewSmall">
            </div>

            <!-- Icon für gelöschte Bilder -->
            <div v-if="image.isDeleted" class="z-10 absolute w-full h-full flex justify-center items-center">
              <i class="fa-solid fa-x text-[70px] text-trader-dark-red"></i>
            </div>
          </div>


          <!-- Toolbar -->
          <div class="flex items-center text-black bg-inactive w-full justify-center">
            <div class="w-1/3  hover:bg-trader-blue hover:text-white flex items-center  justify-center  text-center h-6" @click="showModal(image)"
                 data-ui="show-image-preview"
                 title="Bildvorschau">
              <i class="fa-solid fa-magnifying-glass pr-1 "></i>
            </div>
            <div class="pr-0.5 w-1/3 hover:bg-trader-blue hover:text-white text-center h-6 flex items-center  justify-center"
                 @click="() => { onAssignPicture(image); }" title="Abbildung oder Logo dem Artikel zuweisen"
                 data-ui="assign-image">
              <i class="fa-solid fa-link hover:bg-trader-blue "></i>
            </div>
            <div @click="onSetDelete(image.id, image.type)" data-ui="set-delete-image "
                 class="pr-0.5 w-1/3 hover:bg-trader-blue hover:text-white text-center h-6 flex items-center  justify-center" title="Bild auf Löschen setzen">
              <i class="fa-solid fa-xmark hover:bg-trader-blue "></i> <!--KEINE AHNUNG WAS DER SCHEIß DA SOLL -->
            </div>
          </div>
        </div>


      </div>
    </div>

    <div v-if="searchResult?.length > 6" @click="toggleMore" class="mt-2 flex justify-center bg-trader-dark-gray py-2 hover:bg-trader-hover-background hover:text-white cursor-pointer ">
      <div v-if="tabItemCount == 6" class="cursor-pointer" >Mehr anzeigen</div>
      <div v-else class="cursor-pointer">Weniger anzeigen</div>
    </div>

    <div v-if="hoveredImageInfo"
         @mouseover="mouseEnter(null)"
         @mouseleave="mouseLeave">
      <div class="flex flex-col  flex-grow mt-2 p-2  bg-primary">
        <div class="flex" v-if="hoveredImageInfo.name">
          <span  class="w-20">Name: </span>
          <span class="object-contain" v-if="hoveredImageInfo.name"> {{ hoveredImageInfo.name }}</span>
        </div>
        <div class="flex" v-else>
          <span  class="w-20">Name: </span>
          <span class="object-contain">Noch kein Name </span>
        </div>
        <div class="flex ">
          <span class="w-20">Erstellt: </span><span
            class="object-contain">{{ hoveredImageInfo.dateTimeCreated }}</span>
        </div>
        <div class="flex ">
          <span class="w-20">Geändert: </span><span
            class="object-contain">{{ hoveredImageInfo.dateTimeUpdated }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import ImageView from '../Dialogs/ImageView.vue';
import {eventBus} from "@/application/EventBus";
import Modal from "@/components/Dialogs/Modal.vue";
import index, {mapActions, mapState} from "vuex";
import SignalBus from "@/application/SignalBus";
import Spinner from "@/components/Base/Spinner.vue";

export default {
  name: "ImageTab.vue",

  data() {
    return {
      selectedOption: "picture",
      selectedTeam: 0,
      searchTerm: "",
      searchResult: [],
      page: 0,

      teams: [],
      hoveredImageInfo: null,
      leaveTimeout: null,
      isLoading: false,
      pageStart: 0,
    }
  },
  components: {
    Modal,
    Spinner
  },
  computed: {
    ...mapState('settings', ['tabItemCount']),
    images: function () {
      let searchResults = []
      let i = this.tabItemCount * this.page;
      let counter = 0;
      while (i < this.searchResult.length && counter < this.tabItemCount) {

        searchResults.push(this.searchResult[i])
        i++;
        counter++;
      }
      return searchResults
    },
    pageCount: function () {
      if (this.searchResult == null || this.searchResult.length == 0) {
        return 1;
      }
      return Math.ceil(this.searchResult.length / this.tabItemCount)
    }
  },
  methods: {
    ...mapActions('settings', ['setTabItemCount']),

    toggleMore() {
      if (this.tabItemCount == 6) {
        this.setTabItemCount(9);
      } else {
        this.setTabItemCount(6);
      }
    },
    onAssignPicture: function (image) {
      SignalBus.emit("assign-picture-to-product", image);
    },
    mouseEnter(image) {
      if (this.leaveTimeout !== null) {
        clearTimeout(this.leaveTimeout);
      }
      if (image !== null) {
        this.hoveredImageInfo = image
      }
    },
    mouseLeave() {
      this.leaveTimeout = setTimeout(() => {
        this.hoveredImageInfo = null;
      }, 1000)
    },
    showModal(image) {
      eventBus.openModal(ImageView, {
        pictures: this.images,
        selectedIndex: this.images.indexOf(image),
        showButton: true,
      }, {halfSize: true});
    },
    formatDate(timestamp) {
      let date = new Date(timestamp * 1000);  // Konvertieren Sie den Unix-Zeitstempel in ein JavaScript Datum
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`; // Formatieren Sie das Datum als DD-MM-YYYY
    },
    nextPage() {
      if (this.page < this.pageCount - 1) {
        this.page += 1;
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page -= 1;
      }
    },
    toggle(option) {
      this.selectedOption = option;
      this.search();
    },
    search: async function () {
      this.searchResult = [];
      this.page = 0;
      this.isLoading = true;

      if (this.searchTerm === "") {
        this.isLoading = false;
        return;
      }

      const query = gql`
        query GetImages($searchTerm: String!, $team: Int!, $type: String!) {
          imageSearch(filter: {searchTerm: $searchTerm, team: $team, type: $type}) {
               previewSmall
               previewLarge
               type
               id
               name
               dateTimeCreated
               dateTimeUpdated
               isDeleted
          }
        }
      `;

      const variables = {searchTerm: this.searchTerm, team: this.selectedTeam, type: this.selectedOption};

      try {
        const {data} = await apolloClient.query({query, variables});

        this.searchResult = data.imageSearch;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getTeams() {
      const query = gql`
      query GetTeams{
        teams{
          id
          name
        }
      }
      `;
      try {
        const {data} = await apolloClient.query({query});

        this.teams = data.teams;
      } catch (error) {
        console.error(error);
      }
    },
    async onSetDelete(id, type) {


      const imageData = {
        imageId: id,
        type: type,
      }


      const mutation = gql`
      mutation editOnSetDelete($image: Image!) {
        editOnSetDelete(image: $image) {
          success
        }
      }
    `;

      try {
        // Assume the first item for demonstration; adjust as needed
        const variables = {image: imageData};
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.editOnSetDelete.success) {
          let image = this.images.filter(image => image.id === id)
          if (image.length > 0) {
            image[0].isDeleted = !image[0].isDeleted
          }
        }

      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden ", error);
      }
    },
    clearSearch: function () {
      this.searchTerm = ""
      this.searchResult = []
      this.page = 0
      this.selectedTeam = 0
    }
  },
  mounted() {
    this.getTeams()
  }
}
</script>

<style scoped>
/* Spinner Styles */
.loader {
  border: 5px solid #f3f3f3; /* Light grey */
  border-top: 5px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>